import styled, { css } from 'styled-components';
import { GridProps, BordersProps, grid, border } from 'styled-system';

export const Container = styled.div<
  {
    size: 'small' | 'regular';
  } & BordersProps
>`
  background: radial-gradient(
      56.87% 164.82% at 86.8% 24.4%,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(154, 196, 225, 0.3) 100%
    ),
    #f3f6fa;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 1;
  position: relative;

  ${border};

  ${(props) =>
    props.size === 'regular' &&
    css`
      padding: 14px 16px 12px 16px;
      width: 320px;
      height: 180px;
    `};

  ${(props) =>
    props.size === 'small' &&
    css`
      padding: 10px 12px 8px 12px;
      width: 260px;
      height: 170px;
    `};
`;

export const Row = styled.div<GridProps>`
  display: grid;
  ${grid};
`;

export const Column = styled.div<GridProps & { placeSelf?: string }>`
  min-width: 0;

  ${({ placeSelf }) =>
    placeSelf
      ? css`
          place-self: ${placeSelf};
        `
      : null};

  ${grid};
`;
